import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function PinDark(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path
        d="M23.6071 5.33334H11.3928V18.6667H23.6071V5.33334Z"
        fill="#39383C"
      />
      <path
        d="M10.8928 4.83334H24.1071V19.1667H10.8928V4.83334ZM11.8928 5.83334V18.1667H23.1071V5.83334H11.8928Z"
        fill="#39383C"
      />
      <path
        d="M24.2857 2.66667H10.7143C10.3395 2.66667 10.0357 2.96515 10.0357 3.33334V4.66667C10.0357 5.03486 10.3395 5.33334 10.7143 5.33334H24.2857C24.6605 5.33334 24.9643 5.03486 24.9643 4.66667V3.33334C24.9643 2.96515 24.6605 2.66667 24.2857 2.66667Z"
        fill="#39383C"
      />
      <path
        d="M10.7143 3.16667C10.6073 3.16667 10.5357 3.2496 10.5357 3.33334V4.66667C10.5357 4.75041 10.6073 4.83334 10.7143 4.83334H24.2857C24.3927 4.83334 24.4643 4.75041 24.4643 4.66667V3.33334C24.4643 3.2496 24.3927 3.16667 24.2857 3.16667H10.7143ZM9.5357 3.33334C9.5357 2.6807 10.0717 2.16667 10.7143 2.16667H24.2857C24.9282 2.16667 25.4643 2.6807 25.4643 3.33334V4.66667C25.4643 5.31931 24.9282 5.83334 24.2857 5.83334H10.7143C10.0717 5.83334 9.5357 5.31931 9.5357 4.66667V3.33334Z"
        fill="#39383C"
      />
      <path
        d="M25.6428 18.6667H9.35713C8.98237 18.6667 8.67856 18.9651 8.67856 19.3333V22C8.67856 22.3682 8.98237 22.6667 9.35713 22.6667H25.6428C26.0176 22.6667 26.3214 22.3682 26.3214 22V19.3333C26.3214 18.9651 26.0176 18.6667 25.6428 18.6667Z"
        fill="#39383C"
      />
      <path
        d="M9.35713 19.1667C9.25013 19.1667 9.17856 19.2496 9.17856 19.3333V22C9.17856 22.0837 9.25013 22.1667 9.35713 22.1667H25.6428C25.7498 22.1667 25.8214 22.0837 25.8214 22V19.3333C25.8214 19.2496 25.7498 19.1667 25.6428 19.1667H9.35713ZM8.17856 19.3333C8.17856 18.6807 8.7146 18.1667 9.35713 18.1667H25.6428C26.2854 18.1667 26.8214 18.6807 26.8214 19.3333V22C26.8214 22.6526 26.2854 23.1667 25.6428 23.1667H9.35713C8.7146 23.1667 8.17856 22.6526 8.17856 22V19.3333Z"
        fill="#39383C"
      />
      <path
        d="M16.8214 22.6667H18.1786V32.2465L17.5 32.9965L16.8214 32.2465V22.6667Z"
        fill="#39383C"
      />
      <path
        d="M16.3214 22.1667H18.6786V32.4392L17.5 33.7418L16.3214 32.4392V22.1667ZM17.3214 23.1667V32.0539L17.5 32.2513L17.6786 32.0539V23.1667H17.3214Z"
        fill="#39383C"
      />
    </IconSvg>
  );
}
